import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "folders__wrapper"
}
const _hoisted_2 = { class: "folders" }
const _hoisted_3 = {
  key: 0,
  class: "folders__content"
}
const _hoisted_4 = { class: "folders__item" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "folders__list-nowords"
}
const _hoisted_7 = {
  key: 1,
  class: "folders__create"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CreateFolder = _resolveComponent("CreateFolder")!
  const _component_Loader = _resolveComponent("Loader")!

  return (!_ctx.isLoader)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.t("folders.fullList")), 1),
          (_ctx.shortFolders.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shortFolders, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "folders__item-wrapper"
                  }, [
                    _createVNode(_component_router_link, {
                      to: { name: 'FolderPage', params: { id: item.key } }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("h2", null, _toDisplayString(item.title), 1),
                          (item.listModules != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.listModules, (title) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: title,
                                    class: "folders__title"
                                  }, [
                                    _createElementVNode("p", null, _toDisplayString(title), 1)
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.t("folders.noAdded")), 1)
                              ]))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_CreateFolder)
              ]))
        ])
      ]))
    : (_openBlock(), _createBlock(_component_Loader, { key: 1 }))
}